// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Header layout (HomeHeader1) ========== */
:root {
  --app-header-height: 85px;
  --app-header-actions-height: 43px;
}

/* Outer shell – reserves space in document flow */
header.app-site-header {
  display: block;
  width: 100%;
  height: var(--app-header-height);
  min-height: var(--app-header-height);
  max-height: var(--app-header-height);
  flex-shrink: 0;
  position: relative;
  z-index: 1000;
  overflow: visible;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.header-inner {
  width: 100%;
  height: var(--app-header-height);
  min-height: var(--app-header-height);
  max-height: var(--app-header-height);
  flex-shrink: 0;
  overflow: visible;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Fixed bar – overrides global .header rules from style.css */
.header-inner > #header.header,
.header-inner > .header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: var(--app-header-height);
  min-height: var(--app-header-height);
  max-height: var(--app-header-height);
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  overflow: visible;
  margin: 0;
  padding: 0;
  background: #fff;
  z-index: 1000;
  transition: left 0.3s ease, width 0.3s ease;
  transform: none !important;
}

/* Sidebar open: align header with main content column */
.header-inner > #header.header.shrink,
.header-inner > .header.shrink {
  left: 277px;
  right: auto;
  width: calc(100% - 277px);
  margin-left: 0;
  padding-left: 0;
}

/* Sidebar closed: full-width header */
.header-inner > #header.header:not(.shrink),
.header-inner > .header:not(.shrink) {
  left: 0;
  right: 0;
  width: 100%;
  margin-left: 0;
}

.header-inner .shrink .dashboard-btn {
  display: none;
}

.home-icos-btn {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px 0 20px;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  overflow: visible;
}

.home-inner-icons {
  gap: 20px;
  padding-top: 0;
  padding-bottom: 0;
  align-items: center;
  height: 100%;
  max-height: 100%;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 0 1 auto;
  min-width: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.home-inner-icons .edit-btn {
  width: 28px;
  height: 28px;
  margin-left: 20px;
  flex-shrink: 0;
}

.home-inner-icons .dashboard-btn {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}

.menu-icon {
  font-size: 30px;
  cursor: pointer;
  background: #fff;
  color: #000;
  border-radius: 5px;
  flex-shrink: 0;
}

.logo-scsc {
  width: 226px;
  height: 67px;
  max-height: calc(var(--app-header-height) - 20px);
  object-fit: contain;
  object-position: left center;
  flex-shrink: 0;
}

.logomain {
  margin-left: 0;
}

.logo-scsc.logomain {
  width: 226px;
  height: 52px;
  max-height: calc(var(--app-header-height) - 20px);
}

.button-login-inner {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  flex-shrink: 0;
  margin-right: 10px;
  gap: 12px;
  height: var(--app-header-actions-height);
  max-height: var(--app-header-actions-height);
  position: relative;
  overflow: visible;
}

.header-share-wrap {
  position: relative;
  flex: 0 0 96px;
  width: 96px;
  height: var(--app-header-actions-height);
  min-height: var(--app-header-actions-height);
  max-height: var(--app-header-actions-height);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  z-index: 2;
}

.header-share-wrap--hidden {
  visibility: hidden;
  pointer-events: none;
}

.header-share-wrap > div {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.button-login-inner .header-share-wrap .header-share-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  padding: 0 10px !important;
  margin: 0 !important;
  border-radius: 16px !important;
  border: 1px solid #000 !important;
  background-color: #fff !important;
  color: #3c3c3c !important;
  font-family: 'Figtree', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1 !important;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
}

.button-login-inner .header-share-wrap .header-share-btn img {
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  flex-shrink: 0;
}

.button-login-inner button.sign-out-heade {
  width: 113px;
  min-width: 113px;
  max-width: 113px;
  height: var(--app-header-actions-height);
  min-height: var(--app-header-actions-height);
  max-height: var(--app-header-actions-height);
  padding: 0 8px;
  background-color: rgba(44, 104, 161, 1);
  color: rgba(255, 255, 255, 1);
  font-family: 'Figtree', sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1;
  border: none;
  border-radius: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  box-sizing: border-box;
}

.button-login-inner button.sign-out-heade.is-loading {
  opacity: 0.75;
  cursor: wait;
}

@media screen and (max-width: 1200px) {
  :root {
    --app-header-actions-height: 40px;
  }

  .header-share-wrap {
    flex: 0 0 90px;
    width: 90px;
  }

  .button-login-inner button.sign-out-heade {
    width: 90px;
    min-width: 90px;
    max-width: 90px;
    font-size: 11px;
  }

  .button-login-inner .header-share-wrap .header-share-btn {
    font-size: 12px !important;
  }

  .header-profile-icon-btn {
    width: var(--app-header-actions-height);
    height: var(--app-header-actions-height);
    min-width: var(--app-header-actions-height);
    min-height: var(--app-header-actions-height);
    max-width: var(--app-header-actions-height);
    max-height: var(--app-header-actions-height);
  }
}

@media screen and (max-width: 991px) {
  :root {
    --app-header-actions-height: 34px;
  }

  .home-icos-btn {
    padding: 0 15px 0 12px;
  }

  .home-inner-icons {
    gap: 12px;
  }

  .header-brand {
    gap: 12px;
    min-width: 0;
    flex: 1 1 auto;
  }

  .logo-scsc,
  .logo-scsc.logomain {
    width: 180px;
    height: auto;
    max-height: calc(var(--app-header-height) - 18px);
  }

  .button-login-inner {
    gap: 8px;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .header-share-wrap {
    flex: 0 0 65px;
    width: 65px;
  }

  .button-login-inner .header-share-wrap .header-share-btn {
    font-size: 10px !important;
    padding: 0 4px !important;
  }

  div.button-login-inner button.sign-out-heade {
    width: 72px;
    min-width: 72px;
    max-width: 72px;
    font-size: 9px;
    line-height: 1;
    margin-right: 0;
  }

  .button-login-inner .header-share-wrap .header-share-btn img {
    width: 12px !important;
    height: 12px !important;
  }

  .header-profile-dropdown {
    min-width: 220px;
    max-width: min(320px, calc(100vw - 24px));
  }
}

@media screen and (max-width: 768px) {
  .logo-scsc,
  .logo-scsc.logomain {
    width: 155px;
    max-height: calc(var(--app-header-height) - 18px);
  }

  .home-icos-btn {
    padding: 0 12px 0 10px;
  }

  .header-inner > #header.header.shrink,
  .header-inner > .header.shrink {
    left: 0;
    right: 0;
    width: 100%;
  }
}

@media only screen and (max-width: 480px) {
  :root {
    --app-header-height: 64px;
    --app-header-actions-height: 30px;
  }

  .header-inner .shrink .dashboard-btn {
    display: block;
  }

  .header-brand {
    gap: 10px;
  }

  .logo-scsc,
  .logo-scsc.logomain {
    width: 140px;
    height: 36px;
    max-height: calc(var(--app-header-height) - 16px);
  }

  .header-share-wrap {
    flex: 0 0 72px;
    width: 72px;
  }

  .button-login-inner .header-share-wrap .header-share-btn {
    font-size: 10px !important;
    padding: 0 6px !important;
  }

  div.button-login-inner button.sign-out-heade {
    width: 72px;
    min-width: 72px;
    max-width: 72px;
    font-size: 9px;
    line-height: 1;
  }

  .header-profile-icon-btn svg {
    font-size: 20px !important;
  }

  .header-inner > #header.header.shrink,
  .header-inner > .header.shrink {
    left: 0;
    right: 0;
    width: 100%;
  }

  .header-profile-dropdown {
    min-width: 200px;
    max-width: calc(100vw - 20px);
  }
}

/* ========== Profile dropdown (TFT) ========== */
.header-profile-wrap {
  position: relative;
  flex: 0 0 auto;
  flex-shrink: 0;
  overflow: visible;
  z-index: 2;
}

.header-profile-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--app-header-actions-height);
  height: var(--app-header-actions-height);
  min-width: var(--app-header-actions-height);
  min-height: var(--app-header-actions-height);
  max-width: var(--app-header-actions-height);
  max-height: var(--app-header-actions-height);
  border-radius: 50%;
  border: 1px solid rgba(44, 104, 161, 0.3);
  background: #fff;
  color: #2c68a1;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.header-profile-icon-btn:hover {
  background: #f0f6fc;
  box-shadow: 0 2px 8px rgba(44, 104, 161, 0.15);
}

.header-profile-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 260px;
  max-width: 320px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 2px 10px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(44, 104, 161, 0.12);
  padding: 0;
  z-index: 1101;
  overflow: hidden;
}

/* Profile info block */
.header-profile-dropdown-info {
  padding: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}

.header-profile-dropdown-info-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
}

.header-profile-dropdown-info-row:last-child {
  margin-bottom: 0;
}

.header-profile-dropdown-info-label {
  font-family: 'Figtree', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 2px;
}

.header-profile-dropdown-school {
  font-family: 'Figtree', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
  word-break: break-word;
}

.header-profile-dropdown-email {
  font-family: 'Figtree', sans-serif;
  font-size: 13px;
  color: #475569;
  line-height: 1.4;
  word-break: break-all;
}

/* Menu items */
.header-profile-dropdown-menu {
  padding: 6px 0;
}

.header-profile-dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  font-family: 'Figtree', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, color 0.15s;
}

.header-profile-dropdown-item:hover:not(:disabled) {
  background: #f0f6fc;
  color: #2c68a1;
}

.header-profile-dropdown-item:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.header-profile-dropdown-icon {
  font-size: 20px !important;
  color: #2c68a1;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/HomeHeader1.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;;EAEE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAsC;AACtC;;EAEE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;EACjD,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,wCAAwC;EACxC,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,4CAA4C;EAC5C,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,4CAA4C;EAC5C,cAAc;EACd,uCAAuC;EACvC,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uCAAuC;IACvC,wCAAwC;IACxC,2CAA2C;IAC3C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,cAAc;EAChB;;EAEA;;IAEE,YAAY;IACZ,YAAY;IACZ,iDAAiD;EACnD;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,yCAAyC;EAC3C;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,iDAAiD;EACnD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,OAAO;IACP,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,YAAY;IACZ,YAAY;IACZ,iDAAiD;EACnD;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,OAAO;IACP,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;AACF;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,wCAAwC;EACxC,2CAA2C;EAC3C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2EAA2E;EAC3E,0CAA0C;EAC1C,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* ========== Header layout (HomeHeader1) ========== */\n:root {\n  --app-header-height: 85px;\n  --app-header-actions-height: 43px;\n}\n\n/* Outer shell – reserves space in document flow */\nheader.app-site-header {\n  display: block;\n  width: 100%;\n  height: var(--app-header-height);\n  min-height: var(--app-header-height);\n  max-height: var(--app-header-height);\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1000;\n  overflow: visible;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.header-inner {\n  width: 100%;\n  height: var(--app-header-height);\n  min-height: var(--app-header-height);\n  max-height: var(--app-header-height);\n  flex-shrink: 0;\n  overflow: visible;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Fixed bar – overrides global .header rules from style.css */\n.header-inner > #header.header,\n.header-inner > .header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: var(--app-header-height);\n  min-height: var(--app-header-height);\n  max-height: var(--app-header-height);\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  overflow: visible;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  z-index: 1000;\n  transition: left 0.3s ease, width 0.3s ease;\n  transform: none !important;\n}\n\n/* Sidebar open: align header with main content column */\n.header-inner > #header.header.shrink,\n.header-inner > .header.shrink {\n  left: 277px;\n  right: auto;\n  width: calc(100% - 277px);\n  margin-left: 0;\n  padding-left: 0;\n}\n\n/* Sidebar closed: full-width header */\n.header-inner > #header.header:not(.shrink),\n.header-inner > .header:not(.shrink) {\n  left: 0;\n  right: 0;\n  width: 100%;\n  margin-left: 0;\n}\n\n.header-inner .shrink .dashboard-btn {\n  display: none;\n}\n\n.home-icos-btn {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 25px 0 20px;\n  height: 100%;\n  max-height: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.home-inner-icons {\n  gap: 20px;\n  padding-top: 0;\n  padding-bottom: 0;\n  align-items: center;\n  height: 100%;\n  max-height: 100%;\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 0 1 auto;\n  min-width: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.home-inner-icons .edit-btn {\n  width: 28px;\n  height: 28px;\n  margin-left: 20px;\n  flex-shrink: 0;\n}\n\n.home-inner-icons .dashboard-btn {\n  width: 26px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.menu-icon {\n  font-size: 30px;\n  cursor: pointer;\n  background: #fff;\n  color: #000;\n  border-radius: 5px;\n  flex-shrink: 0;\n}\n\n.logo-scsc {\n  width: 226px;\n  height: 67px;\n  max-height: calc(var(--app-header-height) - 20px);\n  object-fit: contain;\n  object-position: left center;\n  flex-shrink: 0;\n}\n\n.logomain {\n  margin-left: 0;\n}\n\n.logo-scsc.logomain {\n  width: 226px;\n  height: 52px;\n  max-height: calc(var(--app-header-height) - 20px);\n}\n\n.button-login-inner {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  margin-right: 10px;\n  gap: 12px;\n  height: var(--app-header-actions-height);\n  max-height: var(--app-header-actions-height);\n  position: relative;\n  overflow: visible;\n}\n\n.header-share-wrap {\n  position: relative;\n  flex: 0 0 96px;\n  width: 96px;\n  height: var(--app-header-actions-height);\n  min-height: var(--app-header-actions-height);\n  max-height: var(--app-header-actions-height);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: visible;\n  z-index: 2;\n}\n\n.header-share-wrap--hidden {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.header-share-wrap > div {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.button-login-inner .header-share-wrap .header-share-btn {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: 100% !important;\n  padding: 0 10px !important;\n  margin: 0 !important;\n  border-radius: 16px !important;\n  border: 1px solid #000 !important;\n  background-color: #fff !important;\n  color: #3c3c3c !important;\n  font-family: 'Figtree', sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1 !important;\n  white-space: nowrap;\n  overflow: hidden;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.button-login-inner .header-share-wrap .header-share-btn img {\n  width: 16px !important;\n  height: 16px !important;\n  margin: 0 !important;\n  flex-shrink: 0;\n}\n\n.button-login-inner button.sign-out-heade {\n  width: 113px;\n  min-width: 113px;\n  max-width: 113px;\n  height: var(--app-header-actions-height);\n  min-height: var(--app-header-actions-height);\n  max-height: var(--app-header-actions-height);\n  padding: 0 8px;\n  background-color: rgba(44, 104, 161, 1);\n  color: rgba(255, 255, 255, 1);\n  font-family: 'Figtree', sans-serif;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 1;\n  border: none;\n  border-radius: 12px;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.button-login-inner button.sign-out-heade.is-loading {\n  opacity: 0.75;\n  cursor: wait;\n}\n\n@media screen and (max-width: 1200px) {\n  :root {\n    --app-header-actions-height: 40px;\n  }\n\n  .header-share-wrap {\n    flex: 0 0 90px;\n    width: 90px;\n  }\n\n  .button-login-inner button.sign-out-heade {\n    width: 90px;\n    min-width: 90px;\n    max-width: 90px;\n    font-size: 11px;\n  }\n\n  .button-login-inner .header-share-wrap .header-share-btn {\n    font-size: 12px !important;\n  }\n\n  .header-profile-icon-btn {\n    width: var(--app-header-actions-height);\n    height: var(--app-header-actions-height);\n    min-width: var(--app-header-actions-height);\n    min-height: var(--app-header-actions-height);\n    max-width: var(--app-header-actions-height);\n    max-height: var(--app-header-actions-height);\n  }\n}\n\n@media screen and (max-width: 991px) {\n  :root {\n    --app-header-actions-height: 34px;\n  }\n\n  .home-icos-btn {\n    padding: 0 15px 0 12px;\n  }\n\n  .home-inner-icons {\n    gap: 12px;\n  }\n\n  .header-brand {\n    gap: 12px;\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .logo-scsc,\n  .logo-scsc.logomain {\n    width: 180px;\n    height: auto;\n    max-height: calc(var(--app-header-height) - 18px);\n  }\n\n  .button-login-inner {\n    gap: 8px;\n    margin-right: 4px;\n    flex-shrink: 0;\n  }\n\n  .header-share-wrap {\n    flex: 0 0 65px;\n    width: 65px;\n  }\n\n  .button-login-inner .header-share-wrap .header-share-btn {\n    font-size: 10px !important;\n    padding: 0 4px !important;\n  }\n\n  div.button-login-inner button.sign-out-heade {\n    width: 72px;\n    min-width: 72px;\n    max-width: 72px;\n    font-size: 9px;\n    line-height: 1;\n    margin-right: 0;\n  }\n\n  .button-login-inner .header-share-wrap .header-share-btn img {\n    width: 12px !important;\n    height: 12px !important;\n  }\n\n  .header-profile-dropdown {\n    min-width: 220px;\n    max-width: min(320px, calc(100vw - 24px));\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .logo-scsc,\n  .logo-scsc.logomain {\n    width: 155px;\n    max-height: calc(var(--app-header-height) - 18px);\n  }\n\n  .home-icos-btn {\n    padding: 0 12px 0 10px;\n  }\n\n  .header-inner > #header.header.shrink,\n  .header-inner > .header.shrink {\n    left: 0;\n    right: 0;\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  :root {\n    --app-header-height: 64px;\n    --app-header-actions-height: 30px;\n  }\n\n  .header-inner .shrink .dashboard-btn {\n    display: block;\n  }\n\n  .header-brand {\n    gap: 10px;\n  }\n\n  .logo-scsc,\n  .logo-scsc.logomain {\n    width: 140px;\n    height: 36px;\n    max-height: calc(var(--app-header-height) - 16px);\n  }\n\n  .header-share-wrap {\n    flex: 0 0 72px;\n    width: 72px;\n  }\n\n  .button-login-inner .header-share-wrap .header-share-btn {\n    font-size: 10px !important;\n    padding: 0 6px !important;\n  }\n\n  div.button-login-inner button.sign-out-heade {\n    width: 72px;\n    min-width: 72px;\n    max-width: 72px;\n    font-size: 9px;\n    line-height: 1;\n  }\n\n  .header-profile-icon-btn svg {\n    font-size: 20px !important;\n  }\n\n  .header-inner > #header.header.shrink,\n  .header-inner > .header.shrink {\n    left: 0;\n    right: 0;\n    width: 100%;\n  }\n\n  .header-profile-dropdown {\n    min-width: 200px;\n    max-width: calc(100vw - 20px);\n  }\n}\n\n/* ========== Profile dropdown (TFT) ========== */\n.header-profile-wrap {\n  position: relative;\n  flex: 0 0 auto;\n  flex-shrink: 0;\n  overflow: visible;\n  z-index: 2;\n}\n\n.header-profile-icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--app-header-actions-height);\n  height: var(--app-header-actions-height);\n  min-width: var(--app-header-actions-height);\n  min-height: var(--app-header-actions-height);\n  max-width: var(--app-header-actions-height);\n  max-height: var(--app-header-actions-height);\n  border-radius: 50%;\n  border: 1px solid rgba(44, 104, 161, 0.3);\n  background: #fff;\n  color: #2c68a1;\n  cursor: pointer;\n  transition: background 0.2s, box-shadow 0.2s;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n.header-profile-icon-btn:hover {\n  background: #f0f6fc;\n  box-shadow: 0 2px 8px rgba(44, 104, 161, 0.15);\n}\n\n.header-profile-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  min-width: 260px;\n  max-width: 320px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 2px 10px rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(44, 104, 161, 0.12);\n  padding: 0;\n  z-index: 1101;\n  overflow: hidden;\n}\n\n/* Profile info block */\n.header-profile-dropdown-info {\n  padding: 16px;\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.header-profile-dropdown-info-row {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 8px;\n}\n\n.header-profile-dropdown-info-row:last-child {\n  margin-bottom: 0;\n}\n\n.header-profile-dropdown-info-label {\n  font-family: 'Figtree', sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-bottom: 2px;\n}\n\n.header-profile-dropdown-school {\n  font-family: 'Figtree', sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.header-profile-dropdown-email {\n  font-family: 'Figtree', sans-serif;\n  font-size: 13px;\n  color: #475569;\n  line-height: 1.4;\n  word-break: break-all;\n}\n\n/* Menu items */\n.header-profile-dropdown-menu {\n  padding: 6px 0;\n}\n\n.header-profile-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  font-family: 'Figtree', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s, color 0.15s;\n}\n\n.header-profile-dropdown-item:hover:not(:disabled) {\n  background: #f0f6fc;\n  color: #2c68a1;\n}\n\n.header-profile-dropdown-item:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.header-profile-dropdown-icon {\n  font-size: 20px !important;\n  color: #2c68a1;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
